import React, { Component } from "react";
import { Row, Col, Card, Input, Divider, Button } from "antd";
import styled from "styled-components";
import { AiOutlineSearch } from "react-icons/all";
import { GrClose } from "react-icons/gr";
import Tab from "../../components/tab";
import { connect } from "react-redux";
import { DashboardAction } from "../../store/actions";
import TableWrapper from "../../components/Grid";
import CustomModal from "../../components/modals/customModal";
import ProfileStatus from "../../assets/images/profile_success.png";
import DeleteOrder from "../../assets/images/delete_order.png";
import moment from "moment";
const CreditorCard = styled(Card)`
  min-height: 300px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  margin-top: 1em;
`;
class ContractorsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 10,
        column: "email",
        // totalCount: 0,
        // currentCount: 0,
        // total_pages: 0,
        search: "",
        status: "",
      },

      selectedTab: "1",
      userId: "",
      isAllow: "",
    };
  }
  componentDidMount() {
    const { getAccouts } = this.props;
    getAccouts(this.state.filters);
  }
  componentDidUpdate(preProps, preState) {
    const { getAccouts } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }
    if (
      preState.filters.page !== this.state.filters.page ||
      preState.filters.search !== this.state.filters.search ||
      preState.filters.status !== this.state.filters.status
    ) {
      getAccouts(this.state.filters);
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };
  onChangeTab = (key) => {
    // this.setState({
    //   selectedTab: key,
    //   filters: { ...this.state.filters, status: key === "1" ? "" : "allowed" },
    // });
    if (key == 1) {
      this.setState({
        filters: {
          ...this.state.filters,
          status: "",
        },
      });

      this.props.getAccouts({
        ...this.state.filters,
        status: "",
      });
    }

    if (key == 2) {
      this.setState({
        filters: {
          ...this.state.filters,
          status: "active",
        },
      });
      this.props.getAccouts({
        ...this.state.filters,
        status: "active",
      });
    }

    if (key == 3) {
      this.setState({
        filters: {
          ...this.state.filters,
          status: "inactive",
        },
      });
      this.props.getAccouts({
        ...this.state.filters,
        status: "inactive",
      });
    }
  };

  toggleModal = (item) => {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
    });
  };

  handleModal = (userId) => {
    this.props.restrictCustomer(
      userId,
      () => {
        this.toggleModal();
        this.props.getAccouts(this.state.filters);
      },
      "activate",
      this.state.filters
    );
  };

  render() {
    const { isOpenModal } = this.state;
    const columns = [
      {
        title: "CUSTOMERS",
        dataIndex: "name",
        align: "left",
        sortDirections: ["descend", "ascend"],
        key: "name",
        width: '25%',
        className: 'action-class',
        sorter: (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: "DATE",
        dataIndex: "date",
        align: "left",
        sortDirections: ["descend", "ascend"],
        key: "date",
        width: '25%',
        className: 'action-class',
        sorter: (a, b) => a?.date.localeCompare(b?.date),
      },

      {
        title: "STATUS",
        dataIndex: "status",
        align: "left",
        key: "status",
        width: '25%',
        className: 'action-class',
        sorter: (a, b) => a?.status?.localeCompare(b?.status),
      },
      {
        title: "ACTION",
        dataIndex: "action",
        align: "left",
        className: "action-class",
        width: '25%',
      },
    ];
    const customerTableData = this.props.accounts?.map((item, index) => {
      return {
        key: index + 1,
        name: `${item?.user?.first_name} ${item?.user?.last_name}`,
        date: moment(item?.created_at).format("MM-DD-YYYY"),
        align: "left",
        status: item?.status == 2 ? "Active" : "Inactive",
        action: (
          <Row justify="start" gutter={[10, 0]}>
            <Col>
              <Button
                onClick={() =>
                  item?.status == 3
                    ? this.props.allowCustomer(
                      item.id,
                      () => {
                        this.props.getAccouts(this.state.filters);
                      },
                      "deactivate",
                      this.state.filters
                    )
                    : this.setState({
                      isOpenModal: !this.state.isOpenModal,
                      userId: item.id,
                      isAllow: item?.status,
                    })
                }
                type="link"
                style={{
                  color: item?.status == 3 ? "#26a69a" : "red",
                  display: "contents",
                  fontSize: "12px",
                }}
                color="black"
              >
                {item?.status == 3 ? "ACTIVATE" : "DEACTIVATE"}
              </Button>
            </Col>
          </Row>
        ),
      };
    });

    const { filters } = this.state;
    return (
      <Row>
        <Col xl={24}>
          <CreditorCard>
            <Row
              justify="space-between"
              align="middle"
              style={{ display: "flex" }}
            >
              <Col xl={12}>
                <h5 className="text-left">All Customers</h5>
              </Col>
              <Col style={{ display: "flex" }}>
                <AiOutlineSearch
                  size="22"
                  onClick={() =>
                    this.setState({ isClose: !this.state.isClose })
                  }
                  className="pointer-cursor"
                />

                <Input
                  placeholder="Search..."
                  style={{
                    width: this.state.isClose ? "200px" : "0px",
                    padding: 0,
                    background: "transparent",
                    border: "none",
                    borderBottom: "none",
                  }}
                  value={this.state.filters.search}
                  onChange={(e) =>
                    this.setState({
                      filters: {
                        ...this.state.filters,
                        search: e.target.value,
                      },
                    })
                  }
                />
                {this.state.isClose && (
                  <GrClose
                    size="20"
                    onClick={() =>
                      this.setState({
                        isClose: !this.state.isClose,
                        filters: { ...this.state.filters, search: "" },
                      })
                    }
                    style={{ marginRight: "20px" }}
                    className="pointer-cursor"
                  />
                )}
              </Col>
              <Divider />
            </Row>
            <Row>
              <Col xl={24}>
                <Tab
                  onChangeTab={this.onChangeTab}
                  plantData={[
                    {
                      key: "ALL",
                      component: () => (
                        <TableWrapper
                          tableColumns={columns}
                          tableData={customerTableData}
                          metaData={filters}
                          currentPage={this.currentPage}
                          previousPage={this.previousPage}
                          isLoader={this.props.allowedAccountLoading}
                          sorter={() => alert("sorter")}
                          fromOrder={true}
                        />
                      ),
                    },
                    {
                      key: "ACTIVE",
                      component: () => (
                        <TableWrapper
                          tableColumns={columns}
                          tableData={customerTableData}
                          metaData={filters}
                          currentPage={this.currentPage}
                          previousPage={this.previousPage}
                          isLoader={this.props.allowedAccountLoading}
                          fromOrder={true}
                        />
                      ),
                    },
                    {
                      key: "INACTIVE",
                      component: () => (
                        <TableWrapper
                          tableColumns={columns}
                          tableData={customerTableData}
                          metaData={filters}
                          currentPage={this.currentPage}
                          previousPage={this.previousPage}
                          isLoader={this.props.allowedAccountLoading}
                          fromOrder={true}
                        />
                      ),
                    },
                  ]}
                />
              </Col>
            </Row>
            <CustomModal
              visible={isOpenModal}
              onCancelModal={this.toggleModal}
              footer={[
                <Row justify="center">
                  <Col
                    className="d-flex justify-content-center"
                    style={{ width: "100%" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => this.handleModal(this.state.userId)}
                    >
                      YES
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#26a69a ",
                        color: "#fff",
                        width: "30%",
                        border: "none",
                      }}
                      onClick={() => this.toggleModal()}
                    >
                      NO
                    </Button>
                  </Col>
                </Row>,
              ]}
            >
              <Row justify="center">
                <Col className="d-flex justify-content-center" span={24}>
                  <img src={DeleteOrder} />
                </Col>
                <Col span={24} style={{ marginTop: "2rem" }}>
                  <p className="text-center">
                    {this.state.isAllow
                      ? "Are you sure you want to deactivate this contractor?"
                      : "Are you sure you want to allow credit purchases for this  contractor?"}
                  </p>
                </Col>
              </Row>
            </CustomModal>
          </CreditorCard>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    accounts: store.DashboardReducer.accounts,
    metaData: store.DashboardReducer.metaData,
    allowedAccountLoading: store.DashboardReducer.allowedAccount,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAccouts: (params) => dispatch(DashboardAction.getAllCustomerReq(params)),
    allowCustomer: (userId, cb, payload, metaData) =>
      dispatch(DashboardAction.allowCustomerReq(userId, cb, payload, metaData)),
    restrictCustomer: (userId, cb, payload, metaData) =>
      dispatch(
        DashboardAction.restrictCustomerReq(userId, cb, payload, metaData)
      ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorsContainer);
